import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const RoleManagement = () => {

     const navigate = useNavigate();

    const [roles, setRoles] = useState([]);
    const [roleId, setRoleId] = useState("");
    const [roleName, setRoleName] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [userList, setUserList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [verifyUser, setVerifyUser] = useState("");
    const [userDetails, setUserDetails] = useState(null);
    const [verifyLoading, setVerifyLoading] = useState(false);
    const [searchUserId, setSearchUserId] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);

   const [userForm, setUserForm] = useState({
    userId: "",
    userName: "",
    email: "",
    mobile: "",
    roleId: "",
    roleName: ""
});
    // Multi-role support: role ids selected in the Assign User to Role modal
    const [selectedRoleIds, setSelectedRoleIds] = useState([]);
    const API_URL = process.env.REACT_APP_API_URL;


    const handleViewUsers = (roleId) => {
        navigate(`/user-role-management/${roleId}`);
    };

    const getRoles = async () => {

        try {

            const res = await axios.get(
                `${API_URL}api/admin/roles`
            );

            setRoles(res.data);

        } catch (err) {

            console.log(err);

        }

    };

    useEffect(() => {

        getRoles();

    }, []);

 const addRole = async () => {

    const confirmed = window.confirm(
        "SECURITY CONFIRMATION\n\n" +
        "You are about to create a new system role.\n\n" +
        "Roles control user access and permissions throughout the application. " +
        "Creating an incorrect role may result in unauthorized access or operational issues.\n\n" +
        "Please verify:\n" +
        "• Role ID is correct\n" +
        "• Role Name is correct\n" +
        "• Required permissions have been reviewed\n\n" +
        "Do you wish to proceed?"
    );

    if (!confirmed) {
        return;
    }

    try {

        await axios.post(
            `${API_URL}api/admin/roles`,
            {
                role_id: Number(roleId),
                role_name: roleName
            }
        );

        alert("Role Added Successfully");

        setRoleId("");
        setRoleName("");

        getRoles();

    } catch (err) {

        console.log(err);

        if (err.response?.status === 400) {

            alert(
                "⚠ DUPLICATE ROLE ID\n\n" +
                "The Role ID you entered already exists in the database.\n\n" +
                "Duplicate Role IDs are not allowed.\n\n" +
                "Please enter a unique Role ID and try again."
            );

            return;
        }

        alert(
            "Failed to create role. Please try again."
        );

    }

};


    const updateRole = async () => {

    try {

        await axios.put(
            `${API_URL}api/admin/roles/${roleId}`,
            {
                role_name: roleName
            }
        );

        alert("Role Updated Successfully");

        setRoleId("");
        setRoleName("");
        setIsEdit(false);

        getRoles();

    } catch (err) {

        console.log(err);

    }

};

const editRole = (role) => {

    setRoleId(role.role_id);
    setRoleName(role.role_name);
    setIsEdit(true);

};

const createNew = () => {

    setRoleId("");
    setRoleName("");
    setIsEdit(false);

};

    const deleteRole = async (id) => {

    const confirmed = window.confirm(
        "SECURITY WARNING\n\n" +
        "You are about to permanently delete this role.\n\n" +
        "Deleting a role may affect user access, permissions, and system operations.\n\n" +
        "Please ensure:\n" +
        "• This role is no longer required\n" +
        "• No active users depend on this role\n" +
        "• Access permissions have been reviewed\n\n" +
        "This action cannot be easily undone.\n\n" +
        "Do you want to continue?"
    );

    if (!confirmed) {
        return;
    }

    try {

        await axios.delete(
            `${API_URL}api/admin/roles/${id}`
        );

        alert("Role Deleted Successfully");

        getRoles();

    } catch (err) {

        console.log(err);

    }

};

    const refreshPage = () => {

    setRoleId("");
    setRoleName("");
    setIsEdit(false);

    getRoles();

};

const createUserEntry = () => {

    if (!roleName.trim()) {

        alert("Please Enter Role Name");

        return;

    }

    const newUser = {

        sno: userList.length + 1,

        userId: `USR${String(userList.length + 1).padStart(3, "0")}`,

        roleName: roleName

    };

    setUserList([...userList, newUser]);

    alert("User Created Successfully");

};
const saveUser = async () => {

    if (
        !userForm.userId ||
        !userForm.userName ||
        !userForm.email ||
        selectedRoleIds.length === 0
    ) {

        alert(
            "Please Fill All Fields"
        );

        return;

    }

    try {

        await axios.post(
            `${API_URL}api/admin/user-role-assignment`,
            {
                user_id:
                    userForm.userId,

                full_name:
                    userForm.userName,

                email:
                    userForm.email,

                role_ids:
                    selectedRoleIds
            }
        );

        alert(
            "User Created Successfully"
        );

        setShowModal(false);

        setSelectedRoleIds([]);

        setUserForm({
            userId: "",
            userName: "",
            email: "",
            roleId: "",
            roleName: ""
        });

    } 
    
    catch (err) {

    console.log(err);

    if (err.response?.status === 400) {

        alert(
            err.response.data.message
        );

        return;
    }

    alert(
        "Failed To Create User"
    );

}

};

const fetchPartnerDetails = async (userId) => {

    try {

        setSearchLoading(true);

        const res = await axios.get(
            `${API_URL}api/admin/search-user/${userId}`
        );

        console.log("API Response:", res.data);

        const user = res.data.data?.[0];

        if (!user) {
            alert("User Not Found");
            return;
        }

        setUserForm(prev => ({
            ...prev,
            userName: user.business_name || user.full_name || "",
            email: user.business_email_id || "",
            mobile: user.mobile_no || ""
        }));

        const existingRoles =
            Array.isArray(user.roles) &&
            user.roles.length > 0
                ? user.roles
                : (
                    user.role_id !== undefined &&
                    user.role_id !== null &&
                    user.role_id !== ""
                )
                    ? [{
                        role_id: user.role_id,
                        role_name: user.role_name || ""
                    }]
                    : [];

        setSelectedRoleIds(
            existingRoles.map(
                (role) =>
                    role.role_id
            )
        );

    } catch (error) {

        console.log(error);

        alert("User Not Found");

    } finally {

        setSearchLoading(false);

    }

};

const verifyPartnerUser = async () => {

    if (!verifyUser) {

        alert("Enter User ID");

        return;

    }

    try {

        setVerifyLoading(true);

        const res = await axios.get(
            `${API_URL}api/admin/partner-user/${verifyUser}`
        );

        setUserDetails(res.data);

    } catch (error) {

        setUserDetails(null);

        alert("User Not Found");

    } finally {

        setVerifyLoading(false);

    }

};


    return (

        <div className="container-fluid">

            <div className="card">

                <div className="card-header">

<div className="card-header border-0">

    <div
        className="d-flex justify-content-between align-items-center"
    >

        <h1
            style={{
                fontWeight: "700",
                color: "#0B2B4C",
                marginBottom: "0"
            }}
        >
            ROLE MANAGEMENT
        </h1> 

        <button
            className="btn btn-primary"
            onClick={() => {

                setSelectedRoleIds([]);

                setShowModal(true);

            }}
        >
            Add User Role
        </button>

    </div>

</div>

<div className="card mb-4">

    <div className="card-header">
        <h5>User Verification</h5>
    </div>

    <div className="card-body">

        <div className="row">

            <div className="col-md-6">

                <input
                    type="text"
                    className="form-control"
                    placeholder="Enter User ID"
                    value={verifyUser}
                    onChange={(e) =>
                        setVerifyUser(
                            e.target.value
                        )
                    }
                />

            </div>

            <div className="col-md-3">

                <button
                    className="btn btn-primary"
                    onClick={verifyPartnerUser}
                >

                    {
                        verifyLoading
                        ? "Searching..."
                        : "Verify User"
                    }

                </button>

            </div>

        </div>

    </div>

</div>



{
searchResults.length > 0 && (

<div className="card mb-4">

    <div className="card-header">

        <h5>
            Search Results
        </h5>

    </div>

    <div className="card-body">

        <table className="table table-bordered">

            <thead>

                <tr>

                    <th>User ID</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>Role</th>
                    <th>Action</th>

                </tr>

            </thead>

            <tbody>

                {
                    searchResults.map(
                        (user) => (

                        <tr key={user.id}>

                            <td>
                                {user.user_id}
                            </td>

                            <td>
                                {user.full_name}
                            </td>

                            <td>
                                {user.mobile_no}
                            </td>

                            <td>
                                {
                                    Array.isArray(user.roles) &&
                                    user.roles.length > 0
                                        ? user.roles.map(
                                            (role) =>
                                                role.role_name
                                          ).join(", ")
                                        : user.role_name
                                }
                            </td>

                            <td>

                                <button
                                    className="btn btn-success btn-sm"
                                    onClick={() => {

                                        const existingRoles =
                                            Array.isArray(user.roles) &&
                                            user.roles.length > 0
                                                ? user.roles
                                                : (
                                                    user.role_id !== undefined &&
                                                    user.role_id !== null &&
                                                    user.role_id !== ""
                                                )
                                                    ? [{
                                                        role_id:
                                                            user.role_id,
                                                        role_name:
                                                            user.role_name
                                                    }]
                                                    : [];

                                        setSelectedRoleIds(
                                            existingRoles.map(
                                                (role) =>
                                                    role.role_id
                                            )
                                        );

                                        setUserForm({

                                            userId:
                                                user.user_id,

                                            userName:
                                                user.full_name,

                                            email:
                                                user.email,

                                            mobile:
                                                user.mobile_no,

                                            roleId:
                                                existingRoles[0]?.role_id || "",

                                            roleName:
                                                existingRoles[0]?.role_name || ""

                                        });

                                        setShowModal(true);

                                    }}
                                >

                                    Assign Role

                                </button>

                            </td>

                        </tr>

                    ))
                }

            </tbody>

        </table>

    </div>

</div>

)
}

{
userDetails && (

<div className="card mb-3">

    <div className="card-body">

        <h5 className="text-success">
            ✅ User Found
        </h5>

        <hr />

        <p>
            <b>User ID:</b>
            {" "}
            {userDetails.userId}
        </p>

        <p>
            <b>Name:</b>
            {" "}
            {userDetails.userName}
        </p>

        <p>
            <b>Email:</b>
            {" "}
            {userDetails.email}
        </p>

        <p>
            <b>Mobile:</b>
            {" "}
            {userDetails.mobile}
        </p>

        <p>
    <b>Role:</b>{" "}
    {
        Array.isArray(userDetails.roles) &&
        userDetails.roles.length > 0
            ? userDetails.roles.map(
                (role) =>
                    role.role_name
              ).join(", ")
            : userDetails.role_name
    }
</p>

    </div>

</div>

)
}

                </div>

                <div className="card-body">

                    <div className="row mb-4">

                        <div className="col-md-3">

                            <input
    type="number"
    className="form-control"
    placeholder="Role ID"
    value={roleId}
    disabled={isEdit}
    onChange={(e) =>
        setRoleId(e.target.value)
    }
/>

                        </div>

                        {
    showModal && (

        <div
            className="modal d-block"
            tabIndex="-1"
            style={{
                backgroundColor:
                    "rgba(0,0,0,0.5)"
            }}
        >

            <div className="modal-dialog">

                <div className="modal-content">

                    <div className="modal-header">

                        <h5 className="modal-title">
                            Assign User to Role
                        </h5>

                        <button
                            className="btn-close"
                            onClick={() =>
                                setShowModal(false)
                            }
                        />

                    </div>

                    <div className="modal-body">

                        <div className="mb-3">

    <label>
        User ID
    </label>

    <input
        type="text"
        className="form-control"
        placeholder="Enter User ID"
        value={userForm.userId}
        onChange={(e)=>
            setUserForm({
                ...userForm,
                userId:e.target.value
            })
        }
    />

 <button
    className="btn btn-primary"
    disabled={searchLoading}
    onClick={() =>
        fetchPartnerDetails(
            userForm.userId
        )
    }
>

{
searchLoading ? (
<>
<span
className="spinner-border spinner-border-sm me-2"
role="status"
/>
Searching...
</>
) : (
"Search"
)
}

</button>

</div>

                        <div className="mb-3">

                            <label>
                                User Name
                            </label>

                            <input
    type="text"
    className="form-control"
    value={userForm.userName}
    readOnly
/>

                        </div>

                        <div className="mb-3">

    <label>
        Email
    </label>

    <input
    type="email"
    className="form-control"
    value={userForm.email}
    readOnly
/>

</div>

<div className="mb-3">

    <label>
        Mobile
    </label>

    <input
        type="text"
        className="form-control"
        value={userForm.mobile}
        readOnly
    />

</div>

                        <div
    className="mb-3"
    style={{
        overflow: "visible"
    }}
>

                            <label>
                                Roles
                            </label>

     <div
        style={{
            maxHeight: "180px",
            overflowY: "auto",
            border: "1px solid #dee2e6",
            borderRadius: "6px",
            padding: "8px"
        }}
    >

        {
            roles.map((role) => {

                const roleKey =
                    String(role.role_id);

                const isChecked =
                    selectedRoleIds.some(
                        (id) =>
                            String(id) ===
                            roleKey
                    );

                return (

                    <div
                        className="form-check"
                        key={roleKey}
                    >

                        <input
                            className="form-check-input"
                            type="checkbox"
                            checked={isChecked}
                            id={`role-check-${roleKey}`}
                            onChange={() => {

                                setSelectedRoleIds(
                                    (prev) =>
                                        isChecked
                                            ? prev.filter(
                                                (id) =>
                                                    String(id) !==
                                                    roleKey
                                            )
                                            : [
                                                ...prev,
                                                role.role_id
                                            ]
                                );

                            }}
                        />

                        <label
                            className="form-check-label"
                            htmlFor={`role-check-${roleKey}`}
                        >
                            {role.role_name}
                        </label>

                    </div>

                );

            })
        }

    </div>

                        </div>

                    </div>

                    <div className="modal-footer">

                        <button
                            className="btn btn-secondary"
                            onClick={() =>
                                setShowModal(false)
                            }
                        >
                            Cancel
                        </button>

                        <button
                            className="btn btn-success"
                            onClick={saveUser}
                        >
                            Save
                        </button>

                    </div>

                </div>

            </div>

        </div>

    )
}

                        <div className="col-md-3">

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Role Name"
                                value={roleName}
                                onChange={(e) =>
                                    setRoleName(e.target.value)
                                }
                            />

                        </div>

                        <div className="col-md-4 d-flex align-items-center gap-2">

<div className="col-md-4 d-flex gap-2">

    <button
        className={`btn ${
            isEdit ? "btn-warning" : "btn-success"
        }`}
        onClick={() =>
            isEdit
                ? updateRole()
                : addRole()
        }
    >
        {isEdit ? "Update" : "Save"}
    </button>


    {
        isEdit && (
            <>
                <button
                    className="btn btn-secondary"
                    onClick={refreshPage}
                >
                    Refresh
                </button>

                <button
                    className="btn btn-primary"
                    onClick={createNew}
                >
                    Create New
                </button>
            </>
        )
    }

</div>
        
    

</div>

                    </div>

                    <table className="table table-bordered table-hover">

                        <thead
                            style={{
                                backgroundColor: "#1f2937",
                                color: "#fff"
                            }}
                        >

                            <tr>

                                <th>Role ID</th>
                                <th>Role Name</th>
                                <th width="180">Action</th>
                                <th>Users</th>

                            </tr>

                        </thead>

                        <tbody>
{
    roles.map((role) => (
        <tr key={role.role_id}>
            <td>{role.role_id}</td>
            <td>{role.role_name}</td>

            <td>
    <button
        className="btn btn-warning me-2"
        onClick={() => editRole(role)}
    >
        Edit
    </button>

    <button
        className="btn btn-danger"
        onClick={() => deleteRole(role.role_id)}
    >
        Delete
    </button>
</td>

            <td>
                <button
                    className="btn btn-primary"
                    onClick={() =>
                        handleViewUsers(role.role_id)
                    }
                >
                    Users
                </button>
            </td>

        </tr>
    ))
}
</tbody>

                    </table>


                </div>

            </div>

        </div>

    );

};

export default RoleManagement;